import { render, staticRenderFns } from "./ModalRegimeFederal.vue?vue&type=template&id=f6dd3144"
import script from "./ModalRegimeFederal.vue?vue&type=script&lang=js"
export * from "./ModalRegimeFederal.vue?vue&type=script&lang=js"
import style0 from "./ModalRegimeFederal.vue?vue&type=style&index=0&id=f6dd3144&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports